import { render, staticRenderFns } from "./inubbm.vue?vue&type=template&id=7375fa08&scoped=true&"
import script from "./inubbm.vue?vue&type=script&lang=js&"
export * from "./inubbm.vue?vue&type=script&lang=js&"
import style0 from "./inubbm.vue?vue&type=style&index=0&id=7375fa08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7375fa08",
  null
  
)

export default component.exports